import { QueryFactory } from "../../../../Common";
import { Captor } from "../../../../Contracts";
export const QReportsMetaData = QueryFactory(Captor.QueryTypes.ReportsMetaData);
//# sourceMappingURL=QReportsMetaData.js.map